module.exports = __webpack_public_path__ + "static/media/view5.484fa29c.jpg";